import React from 'react';
import SystemStats from './SystemStats';
import SystemHistory from './SystemHistory';
import SystemLiveTransactions from './SystemLiveTransactions';
import SystemLiveTrades from './SystemLiveTrades';

class ComponentErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean }> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.error("Dashboard Widget Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
          <div className="p-4 bg-neutral-900/40 border border-red-500/20 rounded-lg font-mono text-xs text-red-400 uppercase tracking-wider">
            Widget temporary unavailable
          </div>
      );
    }
    return this.props.children;
  }
}

const DashboardStats = () => {
  return (
      <div className="max-w-7xl mx-auto px-2 md:pt-1">
        {/* Main layout grid: side-by-side on lg screens */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">

          {/* Left side: Main Content */}
          <div className="lg:col-span-3 space-y-4 order-2 lg:order-1">
            {/* Middle Section: Realtime Data */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <ComponentErrorBoundary>
                <SystemLiveTransactions/>
              </ComponentErrorBoundary>

              <ComponentErrorBoundary>
                <SystemLiveTrades/>
              </ComponentErrorBoundary>
            </div>

            {/* Bottom Section: Historical Data */}
            <ComponentErrorBoundary>
              <SystemHistory/>
            </ComponentErrorBoundary>
          </div>

          {/* Right side: Vertical Stats on lg, horizontal on mobile/md */}
          <div className="lg:col-span-1 order-1 lg:order-2">
            <ComponentErrorBoundary>
              <SystemStats/>
            </ComponentErrorBoundary>
          </div>
        </div>
      </div>
  );
};

export default DashboardStats;